import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ResourceCard } from "@/components/ResourceCard";

export default function SellerResources() {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/resources")
      .then(({ data }) => setResources(data))
      .catch(() => setResources([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="seller-resources-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
      <div className="max-w-2xl">
        <div className="text-xs tracking-[0.3em] uppercase text-muted-foreground mb-4">◦ Seller Resources</div>
        <h1 className="font-serif text-5xl lg:text-6xl tracking-tight font-light">Seller Resources</h1>
        <p className="mt-6 text-muted-foreground leading-relaxed text-lg">
          Practical guides, tools and resources to help handmade brands grow.
        </p>
      </div>

      <div className="mt-16">
        {loading ? (
          <div className="text-muted-foreground text-sm">Loading resources…</div>
        ) : resources.length === 0 ? (
          <div className="text-center py-20 text-muted-foreground border border-border rounded-sm">
            New guides are on the way. Check back soon.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {resources.map((r) => <ResourceCard key={r.id} resource={r} />)}
          </div>
        )}
      </div>
    </div>
  );
}
